import type { CalculationDependencyConfig } from '@/ts/types/calculation-config.type.ts'

export const createCalculationConfig = (): CalculationDependencyConfig => ({
  monthlyNetBurden: {
    dependsOn: {
      calculation: ['private_buy.netPayout', 'leasing.netPayout']
    }
  },
  absoluteSavings: {
    dependsOn: {
      calculation: ['private_buy.totalCost', 'leasing.totalCost']
    }
  },
  relativeSavings: {
    dependsOn: {
      calculation: ['private_buy.totalCost', 'absoluteSavings']
    }
  },
  'private_buy.grossSalary': {
    dependsOn: {
      field: ['monthly_salary']
    }
  },
  'private_buy.employerSubsidy': {
    dependsOn: null
  },
  'private_buy.leasingRate': {
    dependsOn: null
  },
  'private_buy.monetaryAdvantage': {
    dependsOn: null
  },
  'private_buy.calculationBasis': {
    dependsOn: {
      field: ['monthly_salary']
    }
  },
  'private_buy.tax': {
    dependsOn: {
      field: [
        'federal_state',
        'tax_class',
        'church_tax',
        'child_allowance',
        'pension_insurance',
        'health_insurance',
        'health_insurance_additional_contribution'
      ],
      calculation: ['private_buy.calculationBasis'],
      config: ['federal_states', 'taxes']
    }
  },
  'private_buy.socialInsurance': {
    dependsOn: {
      field: ['federal_state', 'child_allowance', 'health_insurance', 'health_insurance_additional_contribution', 'pension_insurance'],
      calculation: ['private_buy.calculationBasis'],
      config: ['federal_states', 'social_insurance']
    }
  },
  'private_buy.netPayout': {
    dependsOn: {
      calculation: ['private_buy.calculationBasis', 'private_buy.tax', 'private_buy.socialInsurance']
    }
  },
  'private_buy.netBurdenDuration': {
    dependsOn: null
  },
  'private_buy.purchasePrice': {
    dependsOn: {
      field: ['purchase_price']
    }
  },
  'private_buy.insuranceCost': {
    dependsOn: {
      field: ['purchase_price'],
      config: ['insurance_bonus', 'factors']
    }
  },
  'private_buy.expectedUsedPurchasePrice': {
    dependsOn: null
  },
  'private_buy.totalCost': {
    dependsOn: {
      field: ['purchase_price'],
      calculation: ['private_buy.insuranceCost']
    }
  },
  'leasing.grossSalary': {
    dependsOn: {
      field: ['monthly_salary']
    }
  },
  'leasing.employerSubsidy': {
    dependsOn: {
      field: ['employer_subsidy']
    }
  },
  'leasing.leasingRate': {
    dependsOn: {
      field: ['purchase_price', 'employer_tax_deduction'],
      config: ['factors', 'taxes']
    }
  },
  'leasing.monetaryAdvantage': {
    dependsOn: {
      field: ['uvp_price']
    }
  },
  'leasing.calculationBasis': {
    dependsOn: {
      field: ['monthly_salary', 'employer_subsidy', 'uvp_price', 'assumption_of_insurance_costs'],
      calculation: ['leasing.leasingRate', 'leasing.monetaryAdvantage', 'leasing.insuranceBonus']
    }
  },
  'leasing.tax': {
    dependsOn: {
      field: [
        'federal_state',
        'tax_class',
        'church_tax',
        'child_allowance',
        'pension_insurance',
        'health_insurance',
        'health_insurance_additional_contribution'
      ],
      calculation: ['leasing.calculationBasis'],
      config: ['federal_states', 'taxes']
    }
  },
  'leasing.socialInsurance': {
    dependsOn: {
      field: ['federal_state', 'child_allowance', 'health_insurance', 'health_insurance_additional_contribution', 'pension_insurance'],
      calculation: ['leasing.calculationBasis'],
      config: ['federal_states', 'social_insurance']
    }
  },
  'leasing.netPayout': {
    dependsOn: {
      calculation: ['leasing.calculationBasis', 'leasing.tax', 'leasing.socialInsurance', 'leasing.monetaryAdvantage']
    }
  },
  'leasing.netBurdenDuration': {
    dependsOn: {
      calculation: ['monthlyNetBurden'],
      config: ['factors']
    }
  },
  'leasing.purchasePrice': {
    dependsOn: null
  },
  'leasing.insuranceCost': {
    dependsOn: null
  },
  'leasing.insuranceBonus': {
    dependsOn: {
      field: ['purchase_price', 'assumption_of_insurance_costs'],
      config: ['insurance_bonus']
    }
  },
  'leasing.expectedUsedPurchasePrice': {
    dependsOn: {
      field: ['uvp_price'],
      config: ['factors']
    }
  },
  'leasing.totalCost': {
    dependsOn: {
      calculation: ['leasing.netBurdenDuration', 'leasing.expectedUsedPurchasePrice']
    }
  }
})
